import { CrewMember } from '@bechtel/types';

export interface CrewMemberSelectorProps {
  items: CrewMember[];
  fieldName: string;
}
